export const problemsByService = {
  Refrigerators: [
    'Not cooling properly',
    'Freezer not freezing',
    'Water leaking',
    'Ice maker not working',
  ],

  'Washing Machines': [
    'Not draining water',
    'Not spinning',
    'Water leaking',
    'Does not start',
  ],

  Dishwashers: [
    'Not cleaning dishes properly',
    'Not draining water',
    'Water leaking',
    'Does not start',
  ],

  Microwaves: [
    'Not heating food',
    'Buttons or touch panel not working',
    'Turntable not rotating',
    'Sparking inside',
  ],

  Dryers: [
    'Not drying clothes properly',
    'No heat',
    'Making loud noise',
    'Does not start',
  ],

  'Ice Machines': [
    'Not making ice',
    'Ice cubes are too small',
    'Water leaking',
    'Ice maker jammed',
  ],

  Ovens: [
    'Not heating to correct temperature',
    'Uneven heating',
    'Display or controls not working',
    'Door not closing properly',
  ],

  Cooktops: [
    'Burner not igniting',
    'Uneven flame or heating',
    'Cracked glass surface',
    'Controls not responding',
  ],

  'Vent Hoods': [
    'Not pulling air properly',
    'Fan not working',
    'Excessive noise',
    'Lights not working',
  ],

  'Stoves / Ranges': [
    'Burner not working',
    'Oven not heating',
    'Gas smell',
    'Control knobs not working',
  ],

  'Warmer Drawers': [
    'Not heating',
    'Temperature control not working',
    'Drawer not sliding properly',
    'Does not turn on',
  ],

  'Garbage Disposals': [
    'Clogged or jammed',
    'Making humming noise',
    'Leaking under sink',
    'Does not turn on',
  ],

  Freezers: [
    'Not freezing',
    'Excessive frost buildup',
    'Temperature fluctuations',
    'Strange noises',
  ],
};
